// extracted by mini-css-extract-plugin
export var container = "TagwSQM7";
export var title = "_9+rxmKOg";